import React from "react";
import AdminAddFixedPage from "../../Components/Admin/AdminAddFixedPage";
import SideBar from "../../Components/Admin/SideBar";

const AdminAddFixedPages = ()=>{
    return (
      <AdminAddFixedPage />
    )
}

export default AdminAddFixedPages